import { Stock } from './stock.model';

export class StockInventory {
  siteId: number;
  siteName: string;
  items: Array<Stock>;
}
